import React, { useState, useRef, useEffect } from 'react';
import './Header.css';
import { useAuth } from '../context/AuthContext';
import { useNavigate } from 'react-router-dom';
import { CustomPropType } from '../utils/propTypes';

const Header = (props) => {
    const authCtx = useAuth();
    const navigate = useNavigate();
    const [toggleIcon, setToggleIcon] = useState('open');
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const dropdownRef = useRef(null);

    useEffect(() => {
        const handleClickOutside = (e) => {
            if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
                setDropdownOpen(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    const toogleMenu = () => {
        setToggleIcon((prev) => (prev === 'open' ? 'closed' : 'open'));
        props.toggleSidebar();
    };

    return (
        <header className="header">
            <div className='d-flex justify-content-between align-items-center'>
                <div className='menu-toogle-button'>
                    <img src="/assets/logo/company_logo.svg" alt="CompanyLogo" width={'100px'} />
                    {!props.isMobileView && (
                        <button onClick={toogleMenu} className="toggle-button">
                            <i className={`bi bi-chevron-double-${toggleIcon === 'open' ? 'left' : 'right'}`}></i>
                        </button>
                    )}
                </div>

                {props.isMobileView ? (
                    <button onClick={toogleMenu} className="toggle-button">
                        <i className="bi bi-list"></i>
                    </button>
                ) : (
                    <div className="profile-dropdown" ref={dropdownRef}>
                        <button
                            className="toggle-button"
                            onClick={() => setDropdownOpen((prev) => !prev)}
                            title="Profile"
                        >
                            <i className="bi bi-person-circle" style={{ fontSize: '24px' }}></i>
                        </button>
                        {dropdownOpen && (
                            <div className="profile-dropdown-menu">
                                <button
                                    className="profile-dropdown-item"
                                    onClick={() => { setDropdownOpen(false); navigate('/change-password'); }}
                                >
                                    <i className="bi bi-key me-2"></i>Change Password
                                </button>
                                <button
                                    className="profile-dropdown-item profile-dropdown-item--danger"
                                    onClick={() => { setDropdownOpen(false); authCtx.onLogOut(); }}
                                >
                                    <i className="bi bi-box-arrow-right me-2"></i>Logout
                                </button>
                            </div>
                        )}
                    </div>
                )}
            </div>
        </header>
    );
};

Header.propTypes = CustomPropType;

export default Header;
